import { isOrganizationView } from '~/shared/utils/accountUtils';

import { buildAccountCachesFromVolumes } from './buildAccountCachesFromVolumes';
import { transformApiVolume } from './transformVolume';

import type { Account } from '~/shared/utils/types';
import type { Volume } from '~/shared/types/api';
import type { ExplorationVolumeLoadResult } from '../types/exploration';

export function buildApiVolumeByEbsId(rawVolumes: Volume[]): Record<string, Volume> {
  const map: Record<string, Volume> = {};
  for (const v of rawVolumes) {
    if (v.volumeId) {
      map[v.volumeId] = v;
    }
  }
  return map;
}

export function buildCachesFromVolumes(
  rawVolumes: Volume[],
  authAccounts: Account[],
  activeTenantId: string | undefined
): ExplorationVolumeLoadResult {
  const orgView = isOrganizationView(activeTenantId, authAccounts);
  const caches = buildAccountCachesFromVolumes(
    rawVolumes.map((v) => transformApiVolume(v)),
    authAccounts,
    (entry) => orgView && entry.accountId === activeTenantId
  );

  return {
    accounts: caches,
    apiVolumeByEbsId: buildApiVolumeByEbsId(rawVolumes),
  };
}
